import { useParams, useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/kit";
import { LEGAL_DOCS, legalDoc, LEGAL_LAST_UPDATED } from "@/lib/legal";

export default function Legal() {
  const { doc: slug } = useParams();
  const navigate = useNavigate();
  const doc = legalDoc(slug) || LEGAL_DOCS[0];

  return (
    <div className="bd-page">
      <header className="sticky top-0 z-30 border-b border-[#2E1256] bg-[#0B031E]/80 backdrop-blur-xl">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <button onClick={() => navigate("/")}><Logo /></button>
          <button onClick={() => navigate("/")} data-testid="legal-home" className="inline-flex items-center gap-1.5 text-sm font-semibold text-purple-200 hover:text-white transition-colors"><ArrowLeft size={16} /> Back to home</button>
        </div>
      </header>

      <div className="max-w-6xl mx-auto px-6 py-10 grid lg:grid-cols-[240px_1fr] gap-10">
        {/* Doc nav */}
        <aside className="lg:sticky lg:top-24 h-max">
          <div className="text-xs font-semibold tracking-widest uppercase text-[#FF6B35] mb-3">Legal</div>
          <nav className="space-y-1">
            {LEGAL_DOCS.map((d) => (
              <Link key={d.slug} to={`/legal/${d.slug}`} data-testid={`legal-nav-${d.slug}`}
                className={`block px-3 py-2 rounded-lg text-sm transition-colors ${d.slug === doc.slug ? "bg-[#FF2A6D]/15 text-white border border-[#FF2A6D]/30" : "text-purple-300 hover:text-white hover:bg-[#1E0A3E]"}`}>
                {d.title}
              </Link>
            ))}
          </nav>
        </aside>

        {/* Content */}
        <main className="bd-fade-up min-w-0">
          <h1 className="font-head text-3xl sm:text-4xl font-extrabold text-white">{doc.title}</h1>
          <p className="text-sm text-purple-400/70 mt-2">Last updated: {LEGAL_LAST_UPDATED}</p>

          {doc.intro && <p className="text-base text-purple-100/90 mt-6 leading-relaxed">{doc.intro}</p>}

          <div className="mt-6 space-y-7">
            {doc.sections.map((s) => (
              <section key={s.heading}>
                <h2 className="font-head text-lg font-bold text-white mb-2">{s.heading}</h2>
                <div className="space-y-2">
                  {s.body.map((p, i) => (
                    <p key={i} className="text-sm text-purple-200/80 leading-relaxed">{p}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-10 pt-6 border-t border-[#2E1256] text-sm text-purple-300/70">
            Looking for something else? <Link to="/" className="text-[#FF6B7D] font-semibold">Return to BeetDrop</Link>.
          </div>
        </main>
      </div>
    </div>
  );
}
